import { useDispatch, useSelector } from "react-redux";
import BannerHeader from "../../../Components/BannerHeader/BannerHeader";
import CustomerReview from "../../Body/CustomerReview/CutomerReview";
import Gallery from "../../Body/Gallery/Gallery";
import Footer from "../../Footer/Footer";
import PrimaryNav from "../../Header/PrimaryNav/PrimaryNav";
import { ContactUs } from "../Components/ContactUs/ContactUs";
import ServiceVideo from "../Components/ServiceVideo/ServiceVideo";
import FAQ from "../FAQ/FAQ";
import AboutForPublishers from "./AboutForPublishers/AboutForPublishers";
import classes from "./BecomePartner.module.css";
import { useEffect } from "react";
import { getAllFaq } from "../../../Store/actions/FaqAction";
import { urls } from "../../../Routes/Urls";
import useScrollToTop from "../../../Hooks/useScrollToTop";
import useScreenSize from "../../../Hooks/UseScreenSize";
import PrimaryButton from "../../../Components/Buttons/PrimaryButton/PrimaryButton";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import SEO from "../../../Components/SEO";

const bgImage = "Assets/Images/ServicePages/BecomOurPartner.png"

const BecomePartner = () => {
  const dispatch = useDispatch();
  const history = useHistory()
  const crumbs = [
    { title: "Home", path: "/" },
    { title: "Become Our Partner", path: urls.BECOMEPARTNER },
  ];
  const video = useSelector(
    (state) => state.serviceVideo?.videos?.becomeOurPartnerVideo
  );
  const allFaq = useSelector((state) => state.Faq.questions);

  const {isSmallScreen} = useScreenSize()

  useEffect(() => {
    getAllFaq("category", "For Booksellers / Become our Partner", "", dispatch);
  }, []);

  const scrollRef = useScrollToTop();

  return (
    <div ref={scrollRef}>
      <SEO
        canonicalUrl="https://www.rarebiblio.com/bulk-leather-bound-books-for-booksellers"
        title={"Booksellers! Get Leather-Bound Books in Bulk | Rare Biblio"}
        keywords={"Leather Bound Books for Booksellers"}
        description={"Join Rare Biblio’s Bookseller Program! Buy luxury leather-bound books in bulk, access rare & out-of-print titles, and expand your store with premium editions."}
        structuredData={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "Organization",
              "name": "Rare Biblio",
              "alternateName": "Leather Bound Books for Booksellers",
              "url": "https://www.rarebiblio.com/bulk-leather-bound-books-for-booksellers",
              "logo": "https://www.rarebiblio.com/Assets/Icons/logo.jpg",
              "sameAs": [
                "https://rarebiblio.com/",
                "https://www.facebook.com/rarebiblio/",
                "https://x.com/Rarebiblio",
                "https://www.instagram.com/Rarebiblio",
                "https://www.linkedin.com/company/Rarebiblio",
                "https://www.pinterest.com/rare_biblio/"
              ]
            },
            {
              "@type": "FAQPage",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "Why should booksellers partner with Rare Biblio?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Partnering with Rare Biblio allows booksellers to offer exclusive, premium leather-bound books with exceptional craftsmanship. Our books are customizable and cater to a high-end market, giving you the chance to increase profitability and offer your customers unique, high-quality editions."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I offer customized leather-bound books to my customers?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolutely! We provide a wide range of customization options, including leather types, colors, embossing, and more, making your offerings stand out and catering to customers looking for unique, personalized editions."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How can partnering with your platform benefit my bookstore in the long term?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Partnering with us gives your bookstore exclusive access to custom leather-bound editions of any book — something you won’t find anywhere else. By offering these unique, high-quality editions in bulk, you can attract collectors and readers looking for a premium experience, ultimately boosting your sales and creating an additional revenue stream with these beautifully crafted books."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I place customized orders based on my customers’ needs or preferences?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, absolutely! We can craft even a single custom book tailored to your customer’s specific preferences, whether it’s a unique leather color, embossing, or any other personalized detail."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What’s the minimum order requirement for booksellers?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "There’s no minimum order quantity. However, purchasing in larger quantities will allow you to benefit from discounted pricing, making it more cost-effective for booksellers."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Can I offer exclusive or limited-edition books to my customers?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes, you can! We can craft limited-edition books exclusively for your bookstore, available only to your customers. These editions can also feature your personalized bookstore logo, name, and any other unique design elements you’d like."
                  }
                }
              ]
            }
          ]
        }
       }
      />
      <PrimaryNav />
      <BannerHeader
        crumbs={crumbs}
        title={"Bulk Leather Books for Bookseller"}
        bgImage={bgImage}
        desc={ isSmallScreen ? 'Turning possibilities into realities' :
          "Unite with us in a shared commitment to excellence, where every book is a testament to the craftsmanship and the enduring power of stories."
        }
      />

      <ServiceVideo
        title={"Become Our Partner"}
        videoSrc={video}
        desc={"Rare Biblio specializes in crafting exquisite leather-bound books that are fully customizable and meticulously hand-crafted. \n \n Renowned for their superior quality, timeless design, and classic elegance, these books stand as a testament to unparalleled craftsmanship. \n \n Working with us will enable you to provide your customers with a unique selection of beautiful leather-bound books that will win them over and add value to their libraries."}
      />

      <AboutForPublishers />
      <div className={classes.join}>
        <h2>How to Become Our Partner</h2>
        <p>
          To show your interest in joining us as a partner, get in touch with us
          by sending us a message at <a href="mailto:info@rarebiblio.com">info@rarebiblio.com</a>. <br/> <br/> We'll arrange an
          introductory meeting to talk about how we can best collaborate and
          understand your needs.
        </p>
      </div>

      <div className={classes.contactUs}>
        <ContactUs category={"becomeOurPartner"} title={"Partner With Us – Let's Collaborate!"} />
      </div>

      <div className={classes.join}>
        <h2>Explore Our Catalog:</h2>
        <p>
        You can go on and check our catalog section where you can get a glimpse of our collection of books with leather bindings and choose the ones that appeal to your target audience. 
        . <br/> <br/> We'll walk you through the picking process and make suggestions according to the features of your shop.
        </p>

        <PrimaryButton className={classes.explore} onClick={() => history.push(urls.BESTSELLER)}>Explore Our Catalog</PrimaryButton>
      </div>

      <Gallery />

      <CustomerReview />

      <FAQ data={allFaq} />
     

      <Footer />
    </div>
  );
};

export default BecomePartner;
